import React from 'react';
import { createRoot } from 'react-dom/client';
import { connect } from 'react-redux';

import readAttribute from 'common/tools/dom/readAttribute';
import { ReduxUser } from 'common/types';

import FollowUnfollowCollectionButton from 'website/components/FollowUnfollowCollectionButton';
import allocineContainer from 'website/containers/allocineContainer';

export default () => {
  const ConnectedFollowUnfollowCollectionButton = allocineContainer(
    connect((state: { user: ReduxUser }) => ({ user: state.user }))(
      FollowUnfollowCollectionButton
    )
  );

  const buttons = document.getElementsByClassName(
    'js-follow-unfollow-collection-button'
  );

  for (const button of buttons) {
    const collectionId = readAttribute<string, undefined>(
      button,
      'data-collection-id'
    );
    const ownerId = readAttribute<string, undefined>(button, 'data-owner-id');
    if (collectionId && ownerId) {
      const buttonToRemove = button.querySelector('.userprofile-hidden');
      if (buttonToRemove) buttonToRemove.remove();
      const root = createRoot(button);
      root.render(
        <ConnectedFollowUnfollowCollectionButton
          collectionId={collectionId}
          ownerId={ownerId}
        />
      );
    }
  }
};
